import React from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import clsx from 'clsx';

/**
 * Lightweight wrapper around react-hook-form.
 * children receives form methods: (methods) => JSX
 */
export const Form = ({ onSubmit, children, className, options = {}, id, schema }) => {
  const methods = useForm({
    ...options,
    resolver: schema ? zodResolver(schema) : undefined,
  });

  return (
    <form
      id={id}
      onSubmit={methods.handleSubmit(onSubmit)}
      className={clsx('space-y-6', className)}
      noValidate
    >
      {children(methods)}
    </form>
  );
};

Form.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  children: PropTypes.func.isRequired,
  className: PropTypes.string,
  options: PropTypes.object,
  id: PropTypes.string,
  schema: PropTypes.object,
};
